import RecommendedListingsContainer from './recommended_listings_container';

const RecommendedListings = RecommendedListingsContainer;
export default RecommendedListings;
